
<template>

    <div class="CheckboxList"
         type="checkboxlist"
         :nullable="(!FinalRequired)+''"
         :value="ResultValue"
         ControlType="CheckboxList"
         v-show="FinalVisible">
   
        <span v-for="(option,index) in m_Attribute.Options"
              @change="OnValueChange"
              :class="{Checked : CheckedValues.indexOf(option.Value) >= 0 }">

            <input type="checkbox" v-model="CheckedValues"
                   :disabled="!FinalEnabled"
                   :readonly="FinalReadOnly"
                   :value="option.Value" /><span @click="ToggleCheckValue(option.Value)">{{ option.Text }}</span>

            <div v-if="((index+1)%m_Attribute.RepeatColumns)==0"></div>
            <span v-else>&nbsp;</span>

        </span>

    </div>



</template>

<script scoped>
    import TControlBase from '@/Common/TControlBase';
    import Utility from '@/Common/Utility';
    import FieldOptionService from '@/Common/FieldOptionService';
 
    export default {
        name: "t-checkboxlist",
        data() {
            return {
                m_RepeatColumns: 1000,
                SourceValueType: "String", //String or Array
                LastValueChangeTime : new Date(),
                CheckedValues: [],
                m_Attribute: TControlBase.Attribute( {
                                Options: []
                        }
                )
            }
        }
        ,
        //props: ["value", "Attribute", "RepeatColumns", "OptionName",
        //    "ComplexOptionName" ,
        //    "CacheOption"
        //],

        props: [...TControlBase.BaseProps],



        computed: {

            ResultValue: function () {
                let resultValue;

                resultValue = this.CheckedValues.join(",");

                return resultValue;
            },

            //Options: function () {
            //    let options = [];

            //    if (this.Attribute != null && this.Attribute.Options != null) {
            //        options = this.Attribute.Options;
            //    }

            //    if (this.m_Attribute.Options.length > 0) {
            //        options.push(...this.m_Attribute.Options);
            //    }

            //    return options;
            //},

            //Disabled: function () {
            //    let result = false;

            //    if (this.Attribute != null && this.Attribute.Enabled != null) {
            //        result = !this.Attribute.Enabled;
            //    }

            //    return result;
            //}
            //,
            //CssClass: function () {
            //    let result = "";


            //    if (this.Attribute != null && this.Attribute.CssClass != null) {
            //        result = this.Attribute.CssClass;
            //    }

            //    return result;
            //}
            //,


            //ReadOnly: function () {

            //    let result = false;


            //    if (this.Attribute != null && this.Attribute.ReadOnly != null) {
            //        result = this.Attribute.ReadOnly;
            //    }

            //    return result;
            //}

        }
        ,

        methods: {

            OnValueChange(e) {
                let checkValues = [];
                let resultValue = "";
                let i;


                for (i = 0; i < this.CheckedValues.length; i++) {
                    if (this.CheckedValues[i] != "" && this.CheckedValues[i] != null) {
                        checkValues.push(this.CheckedValues[i]);
                    }
                }

                if (this.SourceValueType == "String") {
                    resultValue = checkValues.join(",");
                }
                else {
                    resultValue = checkValues;
                }

                if (this.m_Attribute.Required = true && checkValues.length == 0) {
                    this.DoValidate();
                }

                this.$forceUpdate();
  
                this.LastValueChangeTime = new Date();
                this.$emit("input", resultValue);
            },

            ToggleCheckValue(optionValue) {
                let index;

                if ((index = this.CheckedValues.indexOf(optionValue)) >= 0) {
                    this.CheckedValues.splice(index, 1);
                }
                else {
                    this.CheckedValues.push(optionValue);
                }

                this.OnValueChange();
            },

            UpdateElementByAttribute() {

            },
 
        },

        mounted() {
            this.DoOnMounted();
        },

        beforeMounted() {

        },

        created() {
            
            TControlBase.call(this);

            this.UpdateElementByAttribute();

            if (this.value != null && this.value != "") {
                if (typeof (this.value) == "string") {
                    this.SourceValueType = "String";
                    this.CheckedValues = this.value.split(",")
                }
                else {
                    this.SourceValueType = "Array";
                    if (newVal != null) {
                        this.CheckedValues = this.value;
                    }
                }
            }
             
            
        },

        watch: {
            value: function (newVal, oldVal) {
 
                if (typeof (newVal) != "string") {
                    if (newVal != null) {
                        newVal += "";
                    }
                }

                if (newVal == null) {
                    this.SourceValueType = "String";
                    this.CheckedValues.length = 0;
                }
                else if (typeof (newVal) == "string") {
                    this.SourceValueType = "String";
                    this.CheckedValues = newVal.split(",")
                }
                else {
                    this.SourceValueType = "Array";
                    if (newVal != null) {
                        this.CheckedValues = newVal;
                    }
                }

                if ((new Date() - this.LastValueChangeTime) > 100) {
                    this.ClearError();
                }
                 

                this.$forceUpdate();
            },

  
        }


    }
</script>

<style>

    .CheckboxList span {
        cursor: default;
    }
</style>
